import React, { useEffect, useState, useRef } from 'react';
import { Button, NoData, Layer, LayerBottom, SelectList } from 'components'
import useApp from 'hooks/useApp'
import styles from './index.module.css'
import Lib from 'library'
import Native from 'library/native'
import { useNavigate } from 'react-router-dom'
import { userLogInfoState } from './states'
import { useSetRecoilState } from 'recoil'

const TermsCheck = () => {

	const App = useApp()
	const navigate = useNavigate()
	const mounted = useRef()

	const setUserInfo = useSetRecoilState(userLogInfoState)

	const [buttonDisabled, setButtonDisabled] = useState(true)
	const [terms, setTerms] = useState()
	const [termsToShow, setTermsToShow] = useState()
	const [showDetailLayer, setShowDetailLayer] = useState(false)
	const [allChecked, setAllChecked] = useState(false)
	const [joinInfoLayer, setJoinInfoLayer] = useState(false)
	const [termsOpen, setTermsOpen] = useState(0)

	const showDetail = termsCd => {
		let _terms
		terms.forEach(item => {
			if (item.termsCd === termsCd) _terms = item
		})
		setTermsToShow(_terms)
		setShowDetailLayer(true)
	}

	const getTerms = () => {
		Lib.get(`/api/comm/terms`, {
			termsCtgryCd: "MB_JOIN"
		}, data => {
			const newData = data.map(item => {
				return { ...item, checked: false }
			})
			mounted.current && setTerms(newData)
		})
	}

	const checkThis = (cd) => {
		setTerms(terms.map(item => {
			if (item.termsCd === cd) {
				item.checked = !item.checked
			}
			return item
		}))
	}

	const checkAll = () => {
		setAllChecked(t => {
			setTerms(terms.map(item => {
				item.checked = !t
				return item
			}))
			return !t
		})
	}

	const onNext = () => {
		const agreedTerms = []
		terms.forEach(item => {
			if (item.checked) {
				agreedTerms.push({
					termsCd: item.termsCd,
					termsVer: item.termsVer
				})
			}
		})
		setUserInfo({
			terms: agreedTerms
		})
		navigate("/join")
	}

	useEffect(() => {
		if (terms) {
			let count = 0, essential = true
			terms.forEach(item => {
				if (item.checked) {
					count++
				} else if (item.termsNeedYn === "Y") {
					essential = false
				}
				const ary1 = item.termsItem1Val?.split("|||")
				const ary2 = item.termsItem2Val?.split("|||")
				const ary3 = item.termsItem3Val?.split("|||")
				const ary4 = item.termsItem4Val?.split("|||")
				const ary5 = item.termsItem5Val?.split("|||")
				item.termsItem1Val = ary1[0] ?? null
				item.termsItem1Con = ary1[1] ?? null
				item.termsItem2Val = ary2[0] ?? null
				item.termsItem2Con = ary2[1] ?? null
				item.termsItem3Val = ary3[0] ?? null
				item.termsItem3Con = ary3[1] ?? null
				item.termsItem4Val = ary4[0] ?? null
				item.termsItem4Con = ary4[1] ?? null
				item.termsItem5Val = ary5[0] ?? null
				item.termsItem5Con = ary5[1] ?? null
			})
			if (count === terms.length) {
				setAllChecked(true)
			} else {
				setAllChecked(false)
			}

			if (essential === true) {
				setButtonDisabled(false)
			} else {
				setButtonDisabled(true)
			}
		}
	}, [terms])

	useEffect(() => {
		mounted.current = true
		App.setHeader({
			show: true,
			title: <></>,
			left: undefined,
			right: undefined
		})

		App.setShowNav(false)
		App.setMainClass("white")

		getTerms()

		setTimeout(() => {
			setJoinInfoLayer(true)
		}, 1000)

		return () => {
			mounted.current = false
		}
	}, [])

	return (
		<div className="page">
			<div className={`flex_1 padding ${styles["join-terms"]}`}>
				<h2>약관동의</h2>
				<span className={`${styles.guide} mt_20`}>서비스 이용을 위하여<br />필수 및 선택 약관에 동의해주세요.</span>

				<ul className="terms-list mt_60">
					<li className="mb_40">
						<div className="flex-align_center" onClick={checkAll}>
							<i className={`mr_10 checkMark${allChecked ? " on" : ""}`} />
							<span style={{ fontSize: "1.8rem" }}>약관에 모두 동의할게요</span>
						</div>
					</li>
					{
						terms ? terms.length > 0 ?
							terms.map((item, index) => {
								return (
									<li key={index} onClick={() => {}} className="active">
										<div className="flex-justify_between align_center">
											<div className="flex">
												<i className={`mr_10 checkMark${item.checked ? " on" : ""}`} onClick={() => checkThis(item.termsCd)} />
												<span className="flex_1 flex-align_center" onClick={() => showDetail(item.termsCd)}><strong className={item.termsNeedYn === "Y" ? "" : "gray"}>{item.termsNeedYn === "Y" ? "[필수]" : "[선택]"}</strong> {item.termsNm}</span>
											</div>
											<i className="icon icon_arrow_sm bottom" />
										</div>
										<ul className="terms-menu">
											{item.termsItem1Val && <li><span>{item.termsItem1Val}</span></li>}
											{item.termsItem2Val && <li><span>{item.termsItem2Val}</span></li>}
											{item.termsItem3Val && <li><span>{item.termsItem3Val}</span></li>}
											{item.termsItem4Val && <li><span>{item.termsItem4Val}</span></li>}
											{item.termsItem5Val && <li><span>{item.termsItem5Val}</span></li>}
										</ul>
									</li>
								)
							})
							:
							<NoData />
							:
							[...Array(5)].map((item, index) => {
								return (
									<li className={`flex${index > 0 ? " mt_20" : ""}`} key={index}>
										<div className="skeleton" style={{ width: "2.4rem", height: "2.4rem" }} />
										<div className="skeleton ml_10" style={{ width: "20rem" }} />
									</li>
								)
							})
					}
				</ul>

				{/* 약관동의 수정되었습니다. */}
				{/* <div className={`${styles["join-terms"]} mt_60`}>
					<div className="chk">
						<input type="checkbox" id="checkAll" name="state" />
						<label htmlFor="checkAll">
							<span style={{ color: "#333", fontSize: "1.8rem" }}>약관에 모두 동의할게요.</span>
						</label>
					</div>

					<ul className="terms-list accordion-list mt_40">
						<li className={termsOpen === 0 ? "active" : ""}>
							<div className="flex-justify_between align_center" onClick={() => setTermsOpen(0)}>
								<div className="chk">
									<input type="checkbox" id="check10" name="state" />
									<label htmlFor="check10">
										<span><strong>[필수]</strong> 모니 서비스 이용약관</span>
									</label>
								</div>
								<i className="icon icon_arrow_sm bottom" />
							</div>
							<ul className="terms-menu">
								<li><span>서비스 이용약관</span></li>
								<li><span>개인정보 수집 이용동의</span></li>
								<li><span>개인정보 제 3자 제공동의</span></li>
							</ul>
						</li>
						<li className={termsOpen === 1 ? "active" : ""}>
							<div className="flex-justify_between align_center" onClick={() => setTermsOpen(1)}>
								<div className="chk">
									<input type="checkbox" id="check11" name="state" />
									<label htmlFor="check11">
										<span><strong>[필수]</strong> 본인인증 이용약관</span>
									</label>
								</div>
								<i className="icon icon_arrow_sm bottom" />
							</div>
							<ul className="terms-menu">
								<li><span>개인정보 수집이용 동의</span></li>
								<li><span>고유식별정보 처리 동의</span></li>
								<li><span>통신사 이용약관 동의</span></li>
								<li><span>서비스 이용약관 동의</span></li>
								<li><span>개인정보 3자 제공동의</span></li>
							</ul>
						</li>
						<li className={termsOpen === 2 ? "active" : ""}>
							<div className="flex-justify_between align_center" onClick={() => setTermsOpen(2)}>
								<div className="chk">
									<input type="checkbox" id="check12" name="state" />
									<label htmlFor="check12">
										<span><strong className="gray">[선택]</strong> 신용관리 서비스 이용약관</span>
									</label>
								</div>
								<i className="icon icon_arrow_sm bottom" />
							</div>
							<ul className="terms-menu">
								<li><span>KCB 올크레딧 이용약관</span></li>
								<li><span>개인(신용)정보 수집∙이용동의</span></li>
								<li><span>개인(신용)정보 제 3자 제공 동의(핀테크)</span></li>
								<li><span>개인(신용)정보 제 3자 제공 동의(KCB)</span></li>
							</ul>
						</li>
						<li className={termsOpen === 3 ? "active" : ""}>
							<div className="flex-justify_between align_center" onClick={() => setTermsOpen(3)}>
								<div className="chk">
									<input type="checkbox" id="check13" name="state" />
									<label htmlFor="check13">
										<span><strong className="gray">[선택]</strong> 마케팅 정보 수신 동의</span>
									</label>
								</div>
								<i className="icon icon_arrow_sm bottom" />
							</div>
							<ul className="terms-menu">
								<li><span>마케팅 정보 수신 동의</span></li>
							</ul>
						</li>
					</ul>

					<div className={`${styles["btn-underline"]} mt_60`}>개인정보 처리방침</div>
				</div> */}
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big" onClick={onNext} disabled={buttonDisabled}>동의</Button>
			</div>

			<DetailLayer show={showDetailLayer} closeLayer={() => setShowDetailLayer(false)} terms={termsToShow} />

			<JoinInfoLayer show={joinInfoLayer} closeLayer={() => setJoinInfoLayer(false)} />
		</div>
	)
}

const DetailLayer = (props) => {

	const [selectedTerms, setSelectedTerms] = useState(0)
	const [showSelectList, setShowSelectList] = useState(false)

	const termsVersionList = [
		{ value: "0.3", key: "2021-12-31" },
		{ value: "0.2", key: "2021-11-31" },
		{ value: "0.1", key: "2021-10-27" },
	]

	useEffect(() => {
		if (selectedTerms) {
			// TODO: 해당 버젼 약관 갖고오는 API 
		}
	}, [selectedTerms])

	useEffect(() => {
		setSelectedTerms(termsVersionList[termsVersionList.length - 1].key)
	}, [props.show])

	return (
		<Layer {...props}>
			{props.terms &&
				<div className="page">
					<div className="flex_1 flex-column padding">
						<div className="flex_1">
							<h3>{props.terms.termsNm}</h3>
							<div className="terms-txt mt_20">
								{props.terms.termsConts}
							</div>
						</div>
						<div className="flex-justify_between align_center mt_40" onClick={() => setShowSelectList(true)}>
							<span style={{ color: "#999" }}>이전약관보기</span>
							<span className="flex-align_center">{selectedTerms} <i className="icon icon_arrow_sm bottom ml_15" /></span>
						</div> 
					</div>
					<div className="flex-shrink_0 padding">
						<Button onClick={props.closeLayer} className="btn btn--big">확인</Button>
					</div>

					<SelectList onSelect={(key, value) => {
						setSelectedTerms(key)
					}} data={termsVersionList} show={showSelectList} setShow={setShowSelectList} />

				</div>
			}
		</Layer>
	)
}

const JoinInfoLayer = ({ show, closeLayer }) => {
	const goLink = () => {
		Native.execute("Popup", "openPopup", () => { }, {
			view_id: "external_pop",
			url: "https://www.mydatacenter.or.kr:3441",
			title: `동시회원가입 확인하기`
		})
	}

	return (
		<LayerBottom title="가입현황 안내" show={show} closeLayer={closeLayer} closeButton={false} outside={
			<Button className="btn btn--big btn-layer" onClick={closeLayer}>확인</Button>
		}>
			<div className={styles["warn-box"]}>
				<div className="flex-align_center">
					<strong className="text-red">주의</strong>
					<p className="flex--item_1 ml_15">무분별한 MyData 서비스 가입은 내정보의 <strong>과도한 전송 및 집적</strong>을 초래합니다.</p>
				</div>
			</div>
			<p className="guide-title mt_20">소중한 내정보를 지키면서 편리한 MyData서비스를 이용하시려면 다음 사항들을 꼭 기억해주세요.</p>
			<ul className={`${styles["join-info"]} mt_20`}>
				<li>
					<i className="" />
					<div>- MyData 서비스 가입 전 한번 더 고민해보기</div>
				</li>
				<li>
					<i className="" />
					<div>- 반드시 필요한 MyData 서비스만 가입하기</div>
				</li>
				<li>
					<i className="" />
					<div>- 잘 이용하지 않는 MyData APP은 서비스 탈퇴 후 삭제하기</div>
				</li>
			</ul>
			<p className="guide-title mt_20">현재 이용하는 마이데이터 서비스는 마이데이터 종합 포털 홈페이지(www.mydatacenter.or.kr)에서 확인가능합니다.</p>
			<span onClick={goLink} className="link flex-align_center mt_30" style={{ fontWeight: 500 }}>동시회원가입 확인하기<i className="icon icon_btn_arrow_blue ml_10" /></span>
		</LayerBottom>
	)
}

export default TermsCheck